import axios from 'axios';

export default {

  // fetch items from api
  fetchItems({
    state,
    commit,
    getters,
    dispatch
  }, thresholdPrice) {

    // make XHR call and set state from response data
    axios
      .get(getters.apiUrl, {params: {thresholdPrice: thresholdPrice, take: getters.currentTakeValue}})
      .then(response => {
        dispatch('setStateData', response.data);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
    });
  },

  // set result data action
  // data is JSON response from itemsApi
  setStateData({
    commit
  }, data) {

    commit('setItems', data.items);
    commit('setItemsRemaining', data.remaining);
    commit('setItemsCount', data.total);
    commit('setTotalPages', data.totalPages);
  }
};